import { Controller } from '@hotwired/stimulus';

export default class AlternativeTestController extends Controller {
  static values = {
    tabIndex: Number
  };

  static targets = [
    'choiceButton'
  ];

  chooseAnswer() {
    const choice = this.choiceButtonTargets.find((el) => el.checked);

    this.dispatch('completeAnswer', {
      detail: {
        answer:   choice.value,
        tabIndex: this.tabIndexValue
      }
    });
  }

  disableControls() {
    for (const el of this.choiceButtonTargets) {
      el.disabled = true;
    }
  }
}
